
  var CU;
  var top_goal;
  var mean_width;
  var total_bar_width;
  var group;
  var app_html = '';
  var wrapper_target = "CU_target_cart";
  var curr_for = "amount";
  // var cart_target = 'form[action="/cart"]:last, #cart';
  var cart_target = 'form[action="/cart"]:last';


  jQuery(function(){
    
  
       CU = $;
  
      if(typeof cu_group != "undefined"){
        init_cu();
      }

 

 
});
  
 


  
  async function init_cu(){

     CU(document).on("click", "#cart-icon-bubble", function(){
     var div = document.getElementById("CU_container");
          if (is_present) {
            div.style.display = "block"; // Show the div
          } else {
            div.style.display = "none"; // Hide the div
          }

         
});


   
    let real_amount_comma = "{{amount_with_comma_separator}}";

    let real_no_decimal = "{{ amount_no_decimals }}";


    console.log(currency_format);
    console.log(progress_position);

    if(progress_position!=""){
      cart_target = progress_position;
    }
    console.log(cart_target);



    if (currency_format.includes(real_amount_comma)) {
      curr_for = "amount_with_comma_separator";
    }else if(currency_format.includes(real_no_decimal)){
      curr_for = "amount_no_decimals";

    }


    console.log(curr_for);




  if (localStorage.getItem("drawer") === "true") {
    if(window.location.href.indexOf("/cart") <= -1){
      CU("cart-drawer").addClass("active");
      localStorage.setItem("drawer", "false");
    }
  }
  
  group = JSON.parse(cu_group.replaceAll("#","'"));
  
  var g_types = group.group_type.split(",");
  
  var bar_heading = create_bar_message(group, Number(cart_total));
  
  observeCartChanges(); 
  
  if(app_html == ""){
    app_html = CU(".CU_embed_html").html();  
  }
  
  CU(".CU_embed_html").html("");
  
  for(var g_type of g_types){
  
    if(g_type == "cart" || g_type == "product"){
  
      if(g_type == "cart"){
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
          var items = cart.items;
        
        var product_ids = [
    7994942193834,
    7994934853802,
    7942931218602,
    7923990200490,
    7280989208746,
    7819477483690,
    6937255968938,
    7379877789866,
    6936561746090,
    7798094987434,
    7552981074090,
    7459360538794,
    7709849026730,
    7548244230314,
    7772085977258,
    7907351494826,
    7798085714090,
    7976510226602,
    7966398841002,
    7966400676010,
    7988611612842,
    7988611547306,
    7988558266538,
    7988523401386,
    6937255608490,
    8009099149482,
    8011799199914,
    7995304345770,
    7995218100394,
    7995429748906,
    7995320336554,
    8020963197098,
    7884676759722,
    8014762148010,
    7132460908714,
    7679721210026,
    7819461656746,
    7868339945642,
    7869410279594,
    7869417095338,
    7869421027498,
    7877270438058,
    7877318181034,
    8016922837162,
    8024225611946,
    8029532324010,
    8029559095466,
    8029590388906,
    8029412819114,
    8029113286826,
    8030266785962,
    8030267539626,
    8030268096682,
    8034969845930,
    8036334174378,
    8037500649642,
    8039382024362,
    8039456702634,
    8039473316010,
    8039478624426,
    8040575860906,
    8040585986218,
    7887745417386,
    8041910042794,
    8041948807338,
    8042861396138,
    8042876666026,
    8042880008362,
    8045204209834,
    8046063648938,
    8046070202538,
    8046078165162,
    8046078886058,
    8046092910762,
    8046093238442,
    8049274323114,
    7956454736042,
    7956455030954,
    7956455194794,
    7956456898730,
    7956457029802,
    7956457259178,
    7976013824170,
    7976081195178,
    8081444700330,
    7947766038698,
    7999779963050,
    7947722227882,
    7947755028650,
    7947770003626,
    8094188142762,
    8095671746730,
    8095724535978,
    8095738953898,
    8095746719914,
    8096340377770,
    8096352993450,
    8102510723242,
    8102514557098,
    8103940358314,
    8103942455466,
    8104630714538,
    8107418910890,
    8116191887530,
    8088456265898,
    8088523210922,
    8088607850666,
    8091836252330,
    8091899953322,
    8091901362346,
    8091902017706,
    8126860034218,
    8128001114282,
    8129865285802,
    8130582282410,
    8130582479018,
    8131546153130,
    8131555066026,
    8131803054250,
    8135121502378,
    8135454884010,
    8141441499306,
    8142883651754,
    8142884274346,
    7798785048746,
    7855371714730,
    8048410853546,
    8143734898858,
    8144213672106,
    8144219603114,
    8144454418602,
    8144526999722
];
        
          var final_price = 0;
          
        
            items.forEach(item => {
            // Check if the item's id is in the item_id array
            if (product_ids.includes(item.product_id)) {
              // Add the item's price to the total price
              final_price += item.original_price/100;
            }
          });

   
        init_cart_bar(Number(final_price));
          });
      }
      
  
      if(g_type == "product" && window.location.href.indexOf("/product") > -1){
        
        var wrapper_target = "CU_target_product";
        var product_target = 'form[action*="/cart/add"]:last';
  
        if( CU(product_target).length && in_tiered_savings_collection){
          CU(product_target).append("<div class='"+ wrapper_target +"'>" + bar_heading + "</div>");  
          
        }
      
      }
        
    }
  
    if(g_type == "fixed_top" || g_type == "fixed_bottom"){
      CU(app_html).find('.CU_free_shipping_bar_wrapper').prependTo("body");
  
      if(group.sticky_top_banner && g_type == "fixed_top"){
        CU(".CU_free_shipping_bar_wrapper").addClass("top_stick");
      }else if(g_type == "fixed_bottom"){
        CU(".CU_free_shipping_bar_wrapper").addClass("bottom_stick");
      }
      
      CU(".CU_free_shipping_bar_title").html(bar_heading);
    }
    
  }
  
  
  
  }
  
  async function init_cart_bar(cart_total) {

  
  
  if(CU(cart_target).length){
  
    // remove if already present
    CU(".CU_target_cart").remove();
    CU(cart_target).before("<div class='"+ wrapper_target +"'>" + app_html + "</div>");  

    
    await set_cart_bar(group, "." + wrapper_target, cart_total);
  
   // if(window.location.href.indexOf("/cart") > -1){
      await create_product_slider();  
   // }
  }
  
  // var num_cart_total = Number(cart_total);
  
  manage_gift_in_cart(cart_total);
  }
  
  function set_bar_template(design) {
  
  var f_color = design.foreground_color.replaceAll("'","#");
  
  var b_color = design.background_color.replaceAll("'","#")
  
  var is_gradient = design.is_gradient;
  
  var template_name = design.template_name;
  
  if(template_name == "Rainbow Breeze"){
    CU("#CU_container .bar_container").addClass("rainbow_breeze");
  }else if(template_name == "Blue Sky"){
    CU("#CU_container .bar_container").addClass("blue_sky");
  }else{
    CU("#CU_container .animated-progress").css({
      "background-color": b_color
    });
    
    CU("#CU_container .icon_wrapper .icon").css({
      "border": "2px solid " + f_color,
      "background": "#FFFFFF"
    })
  
    CU("#CU_container .icon_wrapper .icon svg").css({
        "fill": f_color
    });
  
    // after fade-in
    CU("#CU_container .progress-blue span, #CU_container .icon_wrapper .icon.fade_in").css({
        "background": f_color
    });
  
    if(is_gradient){
      CU("#CU_container .progress-blue span, #CU_container .icon_wrapper .icon.fade_in").css({
        "background": "linear-gradient(45deg, color-mix(in srgb, " + f_color + " 50%, white),"+ f_color +")"
      });
    }
    
    CU("#CU_container .icon_wrapper .icon.fade_in svg").css({
        "fill": "#FFFFFF",
    });    
  }
  
  }
  
  function create_bar_message(group, cart_total){
  
  var num_cart_total = cart_total;
  
  var bar_message = '';
  
  var top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }))
  
  for(var tier of group.content) {
  
    var price_with_currency = "<span>" + currency_format.replace("{{amount}}", (tier.tier_goal - cart_total).toFixed(2)) + "</span>";
    if(curr_for=="amount_with_comma_separator"){
      price_with_currency = "<span>" + currency_format.replace("{{amount_with_comma_separator}}", (tier.tier_goal - cart_total).toFixed(2)) + "</span>";
    }else if(curr_for == "amount_no_decimals"){
      price_with_currency = "<span>" + currency_format.replace("{{ amount_no_decimals }}", (tier.tier_goal - cart_total).toFixed(2)) + "</span>";

    }
    if(num_cart_total < tier.tier_goal){


      bar_message = tier.tier_progress_message.replace(/{amount}/g, price_with_currency);


      if(curr_for=="amount_with_comma_separator"){
      bar_message = tier.tier_progress_message.replace(/{amount_with_comma_separator}/g, price_with_currency);
      }else if(curr_for == "amount_no_decimals"){
        bar_message = tier.tier_progress_message.replace(/{ amount_no_decimals }/g, price_with_currency);
  
      }


      
      break;
    }else if(tier.tier_goal == num_cart_total){
      bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount}/g, price_with_currency) + "</span>";

      if(curr_for=="amount_with_comma_separator"){
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_with_comma_separator}/g, price_with_currency) + "</span>";
      }else if(curr_for == "amount_no_decimals"){
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{ amount_no_decimals }/g, price_with_currency) + "</span>";
  
      }


      break;
    }else if(num_cart_total > top_goal && top_goal == tier.tier_goal){
      bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount}/g, price_with_currency) + "</span>";


      if(curr_for=="amount_with_comma_separator"){
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{amount_with_comma_separator}/g, price_with_currency) + "</span>";
      }else if(curr_for == "amount_no_decimals"){
        bar_message = "<span>" + tier.tier_goal_reach_message.replace(/{ amount_no_decimals }/g, price_with_currency) + "</span>";
  
      }
      break;
    }
    
    
  };
  
  return bar_message;
  
  }
  
  async function set_cart_bar(group, target= "", cart_total) {
  
  total_bar_width = CU(target + " .bar_container").width();
  top_goal = Math.max.apply(Math, group.content.map(function(o) { return o.tier_goal; }))
  mean_width = total_bar_width/top_goal;
  
  // var num_cart_total = Number(cart_total);
  
  group.content.forEach((tier) => {
  
    var icon_placement = (mean_width * tier.tier_goal) - 70;
  
    var tier_progress_message = tier.tier_progress_message;
  
    var tier_complete_message = tier.tier_goal_reach_message;
  
    var tier_goal_currency = currency_format.replace("{{amount}}", tier.tier_goal);

    if(curr_for=="amount_with_comma_separator"){
      tier_goal_currency = currency_format.replace("{{amount_with_comma_separator}}", tier.tier_goal);
    }else if(curr_for == "amount_no_decimals"){
      tier_goal_currency = currency_format.replace("{{ amount_no_decimals }}", tier.tier_goal);
    }
    
    switch(tier.tier_type) {
        
      case "free_shipping":
  
        var icon_html = CU(target + " #shipping_icon_template").html();
  
     
        
        var icon_text = CU(icon_html).find(".icon_shipping_text").html(tier.tier_description).end()[0].outerHTML;
  
        var icon_final_text = CU(icon_text).find(".icon_shipping_goal_text").html(tier_goal_currency).end()[0].outerHTML;
        
        break;
  
      case "gift":
        
        var icon_html = CU(target + " #gift_icon_template").html();
  
     
        
        var icon_text = CU(icon_html).find(".icon_gift_text").html(tier.tier_description).end()[0].outerHTML;
  
        var icon_final_text = CU(icon_text).find(".icon_gift_goal_text").html(tier_goal_currency).end()[0].outerHTML;
        
        break;
        
      case "percentage_discount":
  
        var icon_html = CU(target + " #discount_icon_template").html();
  
        var icon_text = CU(icon_html).find(".icon_discount_text").html(tier.tier_description).end()[0].outerHTML;
  
        var icon_final_text = CU(icon_text).find(".icon_discount_goal_text").html(tier_goal_currency).end()[0].outerHTML;
  
        break;
        
      case "fixed_discount":
  
        var icon_html = CU(target + " #discount_icon_template").html();
  
        var icon_text = CU(icon_html).find(".icon_discount_text").html(tier.tier_description).end()[0].outerHTML;
  
        var icon_final_text = CU(icon_text).find(".icon_discount_goal_text").html(tier_goal_currency).end()[0].outerHTML;
        
        break
        
    }
  
    var icom_html_with_loc = CU(icon_final_text).css("left", icon_placement)
    
    CU(target + " .icon_wrapper").append(icom_html_with_loc);
  
  });
  
  await set_progress_bar(Number(cart_total), target);
  
  }
  
  async function set_progress_bar(cart_total, target="") {
  
  var bar_total = (cart_total * mean_width) - 20;
  
  set_bar_message(cart_total);
  
  if(bar_total >= total_bar_width){
    CU(target + " .animated-progress span").attr("data-progress", total_bar_width);
  }else{
    CU(target + " .animated-progress span").attr("data-progress", bar_total);  
  }
  
  
  CU(target + " .animated-progress span").each(function () {
    CU(target + " .animated-progress span").animate(
      {
        width: CU(this).attr("data-progress") + "px",
      },
      {
        duration: 1000,
        step: function(currentStep){
  
          CU(target + ' .icon_wrapper .icon_container .icon').each(function(i, obj) {
              var icon_left = CU(this).parent(".icon_container").css("left").replace("px", "");
  
              if((Math.round(currentStep)-50) >= Math.round(icon_left)){
                CU(this).addClass("fade_in");
              }else{
                CU(this).removeClass("fade_in");
              }
              set_bar_template(group.design);
          });
          
        },
        complete: function(params) {
          
        }
      }
    );
  });
  }
  
  function set_bar_message(cart_total){
  
  var bar_message = create_bar_message(group, cart_total);
  
  if(CU(".CU_free_shipping_bar_title").length){
    CU(".CU_free_shipping_bar_title").html(bar_message);
  }
  
  if(CU("#CU_container .bar_heading").length){
    CU("#CU_container .bar_heading").html(bar_message);
  }
  
  if(CU(".CU_target_product").length){
    CU(".CU_target_product").html(bar_message);
  }
  
  }
  
  window.addEventListener("cart_changed", e => {
  
  var cart_data = e.detail;

    var items = cart_data.items;

       var product_ids = [
    7994942193834,
    7994934853802,
    7942931218602,
    7923990200490,
    7280989208746,
    7819477483690,
    6937255968938,
    7379877789866,
    6936561746090,
    7798094987434,
    7552981074090,
    7459360538794,
    7709849026730,
    7548244230314,
    7772085977258,
    7907351494826,
    7798085714090,
    7976510226602,
    7966398841002,
    7966400676010,
    7988611612842,
    7988611547306,
    7988558266538,
    7988523401386,
    6937255608490,
    8009099149482,
    8011799199914,
    7995304345770,
    7995218100394,
    7995429748906,
    7995320336554,
    8020963197098,
    7884676759722,
    8014762148010,
    7132460908714,
    7679721210026,
    7819461656746,
    7868339945642,
    7869410279594,
    7869417095338,
    7869421027498,
    7877270438058,
    7877318181034,
    8016922837162,
    8024225611946,
    8029532324010,
    8029559095466,
    8029590388906,
    8029412819114,
    8029113286826,
    8030266785962,
    8030267539626,
    8030268096682,
    8034969845930,
    8036334174378,
    8037500649642,
    8039382024362,
    8039456702634,
    8039473316010,
    8039478624426,
    8040575860906,
    8040585986218,
    7887745417386,
    8041910042794,
    8041948807338,
    8042861396138,
    8042876666026,
    8042880008362,
    8045204209834,
    8046063648938,
    8046070202538,
    8046078165162,
    8046078886058,
    8046092910762,
    8046093238442,
    8049274323114,
    7956454736042,
    7956455030954,
    7956455194794,
    7956456898730,
    7956457029802,
    7956457259178,
    7976013824170,
    7976081195178,
    8081444700330,
    7947766038698,
    7999779963050,
    7947722227882,
    7947755028650,
    7947770003626,
    8094188142762,
    8095671746730,
    8095724535978,
    8095738953898,
    8095746719914,
    8096340377770,
    8096352993450,
    8102510723242,
    8102514557098,
    8103940358314,
    8103942455466,
    8104630714538,
    8107418910890,
    8116191887530,
    8088456265898,
    8088523210922,
    8088607850666,
    8091836252330,
    8091899953322,
    8091901362346,
    8091902017706,
    8126860034218,
    8128001114282,
    8129865285802,
    8130582282410,
    8130582479018,
    8131546153130,
    8131555066026,
    8131803054250,
    8135121502378,
    8135454884010,
    8141441499306,
    8142883651754,
    8142884274346,
    7798785048746,
    7855371714730,
    8048410853546,
    8143734898858,
    8144213672106,
    8144219603114,
    8144454418602,
    8144526999722
];
       
  var cart_total = cart_data.items_subtotal_price/100;

  var final_price = 0;

  var cart_ids = [];

    items.forEach(item => {
    // Check if the item's id is in the item_id array
    if (product_ids.includes(item.product_id)) {
      // Add the item's price to the total price
      final_price += item.original_price/100;
      cart_ids.push(item.product_id);
      
    }
  });

    var containsCommonItem = cart_ids.some(item => product_ids.includes(item));
  
    console.log(containsCommonItem);

    
    if(containsCommonItem){
      
       if(window.location.href.indexOf("/cart") > -1){
    
          set_progress_bar(final_price);
          set_bar_message(final_price);
        manage_gift_in_cart(final_price);
        
      }else{
        setTimeout(function(){
          init_cart_bar(final_price);
        }, 200);
      }
  
    }
  
 
  
  });
  
  async function manage_gift_in_cart(cart_total) {
  
  for(var tier of group.content) {
  
    if(tier.tier_type == "gift"){
      
      const newCart = await fetchCart();
  
      for(var item of newCart.items){

        var g_found = false;
        
        if(item.id == tier.tier_gift_variant_id){
          g_found = true;
          break;
        }
      }
      
      // check if gift is already in the cart, if not: add it.
      if(cart_total >= tier.tier_goal){
  
        console.log("Add free gift");
  
        // add gift to cart
        if(!g_found){
          add_to_cart("", tier.tier_gift_variant_id);
        }
        
      }else if(cart_total < tier.tier_goal){ // check if gift is in cart but cart total is less, remove gift in that case
        if(g_found){
          remove_from_cart(tier.tier_gift_variant_id);
        }
      }
    }
  }
  
  
  
  
  }
  
  async function fetchCart() {
  const response = await fetch('/cart.js');
  return response.json();
  }
  
  async function emitCartChanges() {
    const newCart = await fetchCart();
    const event = new CustomEvent("cart_changed", { detail: newCart });
    window.dispatchEvent(event);
  }
  
  function observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        //console.log(entry);
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          emitCartChanges();
        }
      });
    });
  
    cartObserver.observe({ entryTypes: ["resource"] });
  }
  
  async function create_product_slider(){
  
  var s_products = JSON.parse(products_data);
  var slides = '';
  
  if(s_products.upsell_type == "specific_products"){
    
    s_products.productItems.pop();
  
    CU.each( s_products.productItems, function( key, product ) {
    
      slides += '<li class="carousel-item splide__slide"><div class="product-item-card"><div class="left-side"><a href="products/'+ product.handle +'"><img src="'+ product.image +'" alt="'+ product.title +'"></a></div><div class="right-side"><a href="products/'+ product.handle +'"><div class="title_card">'+ product.title +'</div><div class="price_card">'+ product.price_with_money +'</div></a></div><div class="button_container"><a onclick="add_to_cart(this)" data-variant-id="'+ product.variant_id +'" class="cu_button">'+ s_products.cart_text +'</a></div></div></li>'
    
    }); 
    
    CU(".splide__list").html(slides);
  
    
  }else if(s_products.upsell_type == "recommended_products"){
    
    const newCart = await fetchCart();
  
    if(newCart.item_count >= 1){
      
      var r_product_id = newCart.items[0].product_id;
      
      await fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+ r_product_id)
      .then(response => response.json())
      .then(({ products }) => {
        console.log(products);
        CU.each( products, function( key, product ) {

          var p_c = currency_format.replace("{{amount}}", (product.price/100).toFixed(2));

          if(curr_for=="amount_with_comma_separator"){
            p_c = currency_format.replace("{{amount_with_comma_separator}}", (product.price/100).toFixed(2));
          }else if(curr_for == "amount_no_decimals"){
            p_c = currency_format.replace("{{amount_no_decimals}}", (product.price/100).toFixed(2));
          }

          var price_with_currency = p_c;
    
          slides += '<li class="carousel-item splide__slide"><div class="product-item-card"><div class="left-side"><a href="/products/'+ product.handle +'"><img src="'+ product.featured_image +'" alt="'+ product.title +'"></a></div><div class="right-side"><a href="/products/'+ product.handle +'"><div class="title_card">'+ product.title +'</div></a><div class="price_card">'+ price_with_currency +'</div></div><div class="button_container"><a class="cu_button" data-variant-id="'+ product.variants[0].id +'" onclick="add_to_cart(this)">'+ s_products.cart_text +'</a></div></div></li>'
    
        });  
        
        CU(".splide__list").html(slides);
    
      });
    } 
  }
  
  
  if(s_products.upsell_type != "none"){
    setTimeout(activate_slider, 500);
  }
  
  }
  
  function activate_slider(){
  var splide = new Splide( '.splide', {
        type   : 'loop',
        perPage: 1,
        perMove: 1,
        pagination: false,
        gap: 30,
        padding: 15,
        breakpoints: {
          840: {
            perPage: 1,
          },
        }
      } );
    
  splide.mount();
  }
  
  function add_to_cart(th, variant_id = '') {
  
  if(variant_id == '')
    var variant_id = CU(th).data("variant-id");
  
  let formData = {
   'items': [{'id': variant_id, 'quantity': 1}]
  };
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
  
    localStorage.setItem("drawer", "true");
  
    window.location.reload(true);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  }
  
  function remove_from_cart(variant_id) {
  
  let updates = {
    [variant_id]: 0
  };
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    localStorage.setItem("drawer", "true");
    window.location.reload(true);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  }
  
  
  

